import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface HasUnsavedChanges {
    confirmLeave(): Observable<boolean> | boolean;
}

/** Ao sair da tela com o layout alterado, pergunta se salva antes. */
@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<HasUnsavedChanges> {
    canDeactivate(component: HasUnsavedChanges): Observable<boolean> | boolean {
        return component?.confirmLeave ? component.confirmLeave() : true;
    }
}
